var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PSelect',_vm._b({attrs:{"items":_vm.locations,"value":_vm.value,"focus":_vm.focus,"required":_vm.required,"itemText":"name","itemValue":"key"},on:{"input":_vm.onInput},scopedSlots:_vm._u([{key:"default",fn:function({ item }){return [_vm._v(" "+_vm._s(item.name)+" ")]}}])},'PSelect',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }